// Thin <img> wrapper. Asset PNGs are pre-processed (transparent background,
// sized for UI), so no runtime chroma-keying or resizing is needed here.
import React from "react";

export default function KeyedImage({ src, className = "", style, alt = "" }) {
  return <img src={src} alt={alt} className={className} style={style} />;
}
